import type { ToastType } from '@/ui/components/toast';

export type { ToastType };

export interface ToastInput {
  title: string;
  message: string;
  type: ToastType;
}

const TYPES: readonly ToastType[] = ['info', 'success', 'warning', 'danger'];

// js.erb には 'error' を渡す箇所が 2 つある（bootstrap-notify では無色だった）。
// 不明な値は bootstrap-notify の既定と同じ info にする
export function toToastType(raw: string): ToastType {
  if (raw === 'error') return 'danger';
  return (TYPES as readonly string[]).includes(raw)
    ? (raw as ToastType)
    : 'info';
}
